import axios from "axios";
import React, { useEffect } from "react";
import { useState } from 'react';
import { base_url } from "../../utils/AxiosConfig";
import { format } from "date-fns";
import { toast } from "react-toastify";
import { Oval } from "react-loader-spinner";


const ViewHolidayPopUp = ({ popUpData, allBranchData }) => {

  const storedUserDataArray = JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  let companyCode = null

  if (storedUserDataArray) {
    companyCode = storedUserDataArray[0].cmpcode
  }

  console.log('allBranchData', allBranchData)

  const [deptNoArray, setDeptNoArray] = useState([
    'HO', 'ABC', 'XYZ'
  ])

  const [branch, setBranch] = useState(null)

  const [branchHolidayList, setBranchHolidayList] = useState([])

  const [publicHolidayList, setPublicHolidayList] = useState([])

  const [loader, setLoader] = useState(false)


  const fetchBranchHolidayList = async () => {
    setLoader(true)
    try {
      const response = await axios.get(`${base_url}api/CRMHRHolidayList/${companyCode}/HOLIDAYMAIN/${branch}`)

      if (response.status === 200) {
        setBranchHolidayList(response.data)
        setLoader(false)

      }
    } catch (error) {
      console.log('fetchBranchHolidayListError', error)
      setLoader(false)

    }
  }

  const fetchPublicHolidayList = async () => {
    setLoader(true)
    try {
      const response = await axios.get(`${base_url}api/CRMHRHolidayList/${companyCode}/HOLIDAYSUB/${branch}`)

      if (response.status === 200) {
        setPublicHolidayList(response.data)
        setLoader(false)

      }
    } catch (error) {
      console.log('fetchPublicHolidayListError', error)
      setLoader(false)

    }
  }

  const deletePublicHoliday = async (docid) => {
    try {
      const response = await axios.get(`${base_url}api/CRMHRHolidayDelete/${companyCode}/${docid}`)

      if (response.status === 200) {
        fetchPublicHolidayList()

        toast.success('Deleted public Holiday')

      }
    } catch (error) {
      toast.error('some error in deleting holiday')
    }
  }


  useEffect(() => {
    if (branch && branch !== 'All') {
      fetchBranchHolidayList()
      fetchPublicHolidayList()
    }
  }, [branch])

  //  console.log('branchHolidayList',branchHolidayList)
  //  console.log('publicHolidayList',publicHolidayList)

  console.log('loader', loader)

  return (
    <div style={{
      backgroundColor: 'white',
      marginTop: '16px', padding: '16px'
    }}>

      <div style={{
        backgroundColor: 'white',
        margin: '16px 0px'
      }}>
        <h1 class="modal-title  text-secondary fs-small" id="staticBackdropLabel">Holiday List</h1>
      </div>


      <div className="container-fluid h-auto">


        <ul class="nav nav-tabs" id="myTab" role="tablist">

          <li class="nav-item" role="presentation">
            <a class="nav-link" id="View-profile-tab" data-bs-toggle="tab" href="#View-profile" role="tab" aria-controls="View-profile" aria-selected="false">Public Holiday</a>
          </li>
        </ul>

        <div class="form-check d-flex align-items-center gap-2 mt-2 mb-2">
          <label for="exampleInputEmail1" class="fs-small text-secondary">Branch</label>
          <select class="form-select" style={{ width: '150px' }} aria-label="Default select example" value={branch} onChange={(e) => setBranch(e.target.value)}>
            <option selected value='0'>Select</option>
            {/* <option value="1">All</option> */}

            {
              allBranchData.map((item, index) => (
                <option value={item.DEPTNO}>{item.DEPTNO}</option>
              ))
            }
          </select>
        </div>


        <div className="col-md-12 tab-pane fade" id="View-home" role="tabpanel" aria-labelledby="View-home-tab">
          <div className="container scroll" style={{ maxHeight: '250px' }}>
            <table class="table" >
              <tbody>
                <tr className="">
                  <td>SI No</td>
                  <td>Sun</td>
                  <td>Sat</td>
                  <td>Fri</td>
                  <td>Chk1</td>
                  <td>Chk2</td>
                  <td>Chk3</td>
                  <td>Absent Day</td>
                  <td>Late (min)</td>
                  <td>Alert (min)</td>
                  <td>DeptNo</td>
                  {/* <td>Delete</td> */}
                </tr>

                {
                  branchHolidayList && branchHolidayList.length > 0 &&
                  branchHolidayList.map((item, index) => (
                    <tr className="dataTr" key={index}>
                      <td>{index + 1}</td>
                      <td>{item.sun}</td>
                      <td>{item.sat}</td>
                      <td>{item.fri}</td>
                      <td>{item.chk1}</td>
                      <td>{item.chk2}</td>
                      <td>{item.chk3}</td>
                      <td>{item.cmbabsent}</td>
                      <td>{item.cmblate}</td>
                      <td>{item.cmbalert}</td>
                      <td>{item.deptno}</td>
                      {/* <td>
                                  <button className="red-btn">Delete</button>
                                </td> */}
                    </tr>
                  ))
                }


                {
                  !loader && branchHolidayList.length === 0 &&
                  <tr className="dataTr">
                    <td colSpan={11}>No Data available</td>
                  </tr>
                }


              </tbody>
            </table>
          </div>
        </div>

        <div className="col-md-12 tab-pane fade show active" id="View-profile" role="tabpanel" aria-labelledby="View-profile-tab">
          <div className="container scroll" style={{ maxHeight: '250px' }}>
            <table class="table" >
              <tbody>
                <tr className="">
                  <td>SI Now</td>
                  <td>Date </td>
                  <td>Holiday Name</td>
                  <td>DeptNo</td>
                  <td>Delete</td>
                </tr>

                {
                  publicHolidayList && publicHolidayList.length > 0 &&
                  publicHolidayList.map((item, index) => (
                    <tr className="dataTr" key={index}>
                      <td>{index + 1}</td>
                      <td>{item.hdate ? item.hdate.split("T")[0] : "N/A"}</td> {/* Check if hdate exists */}
                      <td>{item.hname}</td>
                      <td>{item.deptno}</td>
                      <td onClick={() => deletePublicHoliday(item.docid)}>
                        <button className="red-btn">Delete</button>
                      </td>
                    </tr>
                  ))
                }


                {
                  !loader && publicHolidayList.length === 0 &&
                  <tr className="dataTr">
                    <td colSpan={5}>No Data available</td>
                  </tr>
                }

                {
                  loader &&
                  <Oval
                    visible={true}
                    height="60"
                    width="60"
                    color="#4fa94d"
                    ariaLabel="oval-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                  />
                }

              </tbody>
            </table>
          </div>
        </div>


      </div>

      {/* <div>
        <div
          class="modal fade"
          id="staticBackdropnew"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabindex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-xl">
            <div class="modal-content">
              <div class="modal-header">
                <h1
                  class="modal-title  text-secondary fs-small"
                  id="staticBackdropLabel"
                >
                  Holiday List
                </h1>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <div className="container-fluid h-auto">
                 

                  <ul class="nav nav-tabs" id="myTab" role="tablist">
                   
                    <li class="nav-item" role="presentation">
                      <a class="nav-link" id="View-profile-tab" data-bs-toggle="tab" href="#View-profile" role="tab" aria-controls="View-profile" aria-selected="false">Public Holiday</a>
                    </li>
                  </ul>

                  <div class="form-check d-flex align-items-center gap-2 mt-2 mb-2">
                    <label for="exampleInputEmail1" class="fs-small text-secondary">Branch</label>
                    <select class="form-select" style={{ width: '150px' }} aria-label="Default select example" value={branch} onChange={(e) => setBranch(e.target.value)}>
                      <option selected value=''>Select</option>
                      <option value="1">All</option>

                      {
                        allBranchData.map((item, index) => (
                          <option value={item.deptno}>{item.deptno}</option>
                        ))
                      }
                    </select>
                  </div>


                  <div className="col-md-12 tab-pane fade" id="View-home" role="tabpanel" aria-labelledby="View-home-tab">
                    <div className="container scroll" style={{ maxHeight: '250px' }}>
                      <table class="table" >
                        <tbody>
                          <tr className="">
                            <td>SI No</td>
                            <td>Sun</td>
                            <td>Sat</td>
                            <td>Fri</td>
                            <td>Chk1</td>
                            <td>Chk2</td>
                            <td>Chk3</td>
                            <td>Absent Day</td>
                            <td>Late (min)</td>
                            <td>Alert (min)</td>
                            <td>DeptNo</td>
                            
                          </tr>

                          {
                            branchHolidayList && branchHolidayList.length > 0 &&
                            branchHolidayList.map((item, index) => (
                              <tr className="dataTr" key={index}>
                                <td>{index + 1}</td>
                                <td>{item.sun}</td>
                                <td>{item.sat}</td>
                                <td>{item.fri}</td>
                                <td>{item.chk1}</td>
                                <td>{item.chk2}</td>
                                <td>{item.chk3}</td>
                                <td>{item.cmbabsent}</td>
                                <td>{item.cmblate}</td>
                                <td>{item.cmbalert}</td>
                                <td>{item.deptno}</td>
                             
                              </tr>
                            ))
                          }


                          {
                            branchHolidayList.length === 0 &&
                            <tr className="dataTr">
                              <td colSpan={11}>No Data available</td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="col-md-12 tab-pane fade show active" id="View-profile" role="tabpanel" aria-labelledby="View-profile-tab">
                    <div className="container scroll" style={{ maxHeight: '250px' }}>
                      <table class="table" >
                        <tbody>
                          <tr className="">
                            <td>SI Now</td>
                            <td>Date </td>
                            <td>Holiday Name</td>
                            <td>DeptNo</td>
                            <td>Delete</td>
                          </tr>

                          {
                            publicHolidayList && publicHolidayList.length > 0 &&
                            publicHolidayList.map((item, index) => (
                              <tr className="dataTr" key={index}>
                                <td>{index + 1}</td>
                                <td>{item.hdate ? item.hdate.split("T")[0] : "N/A"}</td>
                                <td>{item.hname}</td>
                                <td>{item.deptno}</td>
                                <td onClick={() => deletePublicHoliday(item.docid)}>
                                  <button className="red-btn">Delete</button>
                                </td>
                              </tr>
                            ))
                          }


                          {
                            publicHolidayList.length === 0 &&
                            <tr className="dataTr">
                              <td colSpan={5}>No Data available</td>
                            </tr>
                          }

                        </tbody>
                      </table>
                    </div>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

    </div>
  );
};

export default ViewHolidayPopUp;
